export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-female-symbol-e7f24a03bd5374ad183edd12e38a33a4.svg";